import { Trans, useTranslation, withTranslation } from 'react-i18next';
import {
  Box,
  Grid,
  InputLabel,
  Typography,
  Checkbox,
  FormControl,
  Link,
} from '@material-ui/core';
import compose from 'ramda/src/compose';
import LocaleKeys from '../../../../../locales/keys';
import { makeStyles } from '@material-ui/core/styles';
import postMessage from '../../../../../utils/postMessage';
import { newsFieldLocation } from '../../../../../constants/checkout.constant';
import checkBoxIcon from '../../../../../images/checkbox-svgrepo-com.svg';
import checkBoxUncheckedIcon from '../../../../../images/checkbox-unchecked-svgrepo-com.svg';
import CustomLink from '../../../../../subscriptionInfo/components/upgradeSubscription/components/customLink';

const useStyles = makeStyles((theme) => ({
  innerContainer: {
    flexBasis: 0,
    '& .MuiIconButton-root': {
      padding: '4px 2px 0 0',
    },
  },
  checkbox: {
    width: '13px',
    height: '13px',
    backgroundColor: '#ffffff',
    marginTop: '5px',
    '& .MuiSvgIcon-root': {
      fontSize: '17px',
      background: theme?.palette?.custom?.white,
    },
  },
  linkText: {
    color: '#333',
  },
}));

function RecieveNewsField(props) {
  const { form = {}, name, customClasses, type } = props;
  const { values = {} } = form;
  const { t } = useTranslation();
  const classes = useStyles();

  const isCheckoutField = type === newsFieldLocation.Checkout;
  const publishEvent = (event, params) => {
    postMessage(event, params);
  };

  const CheckoutField = () => (
    <span>
      <span>{t(LocaleKeys.payment.orders.termsTextPrefix)}</span>
      <Link
        data-testid="terms-and-condition-link"
        className={`${classes.link} `}
        color="textPrimary"
        underline="none"
        onClick={() => {
          publishEvent('module.termsAndConditionsButton', {});
        }}
      >
        {t(LocaleKeys.payment.orders.termsTextTCLink)}
      </Link>
      <span>{t(LocaleKeys.payment.orders.termsTextInter1)}</span>
      <Link
        data-testid="terms-and-condition-link"
        className={`${classes.link} `}
        color="textPrimary"
        underline="none"
        onClick={() => {
          publishEvent('module.privayPolicyButton', {});
          publishEvent('module.privacyPolicyButton', {});
        }}
      >
        {t(LocaleKeys.payment.orders.termsTextPPLink)}
      </Link>
      <span>{t(LocaleKeys.payment.orders.termsTextInter2)}</span>
      <Link
        data-testid="terms-and-condition-link"
        className={`${classes.link} `}
        color="textPrimary"
        underline="none"
        onClick={() => {
          publishEvent('module.subscriptionTerms', {});
        }}
      >
        {t(LocaleKeys.payment.orders.termsTextSTLink)}
      </Link>
      <span>{t(LocaleKeys.payment.orders.termsTextSuffix)}</span>
    </span>
  );

  const MyAccountField = () => (
    <span>
      <Trans
        i18nKey={LocaleKeys.accountInfo.receiveLatestNews}
        components={{
          CustomLink: <CustomLink />,
        }}
        values={{ link: ASCENDON_ENV_CONFIG.privacyPolicyLink }}
      />
    </span>
  );

  return (
    <Box className={`field field--${name}`}>
      <Box component={Grid} container>
        <Box component={Grid} item xs={1} className={classes.innerContainer}>
          <FormControl className={`field__form-control`}>
            <Checkbox
              data-cy="field__checkbox"
              data-testid="receivedLatestNews"
              icon={
                <img src={checkBoxUncheckedIcon} alt="checkBoxUncheckedIcon" />
              }
              checkedIcon={<img src={checkBoxIcon} alt="checkIcon" />}
              color="secondary"
              disableRipple={true}
              className="field__checkbox"
              name={name}
              checked={values[name] || false}
              onChange={(e) => {
                form.setFieldValue(name, !values[name]);
              }}
            />
          </FormControl>
        </Box>
        <Box component={Grid} item xs={11} style={{ alignSelf: 'center' }}>
          <InputLabel>
            <Typography
              className={`${classes.linkText} ${
                customClasses && customClasses.titilliumFont
              }`}
            >
              {isCheckoutField ? CheckoutField() : MyAccountField()}
            </Typography>
          </InputLabel>
        </Box>
        <Box component={Grid} item xs={12}>
          {form?.errors?.[name] ? (
            <Box ml={3} mt={2} className={`field__errorBox`}>
              <Typography variant="body2" color="error">
                {form.errors[name]}
              </Typography>
            </Box>
          ) : null}
        </Box>
      </Box>
    </Box>
  );
}

export default compose(withTranslation())(RecieveNewsField);
